export enum ErrorType {
  PERMISSION = 'permissions',
  GENERIC = 'generic',
  DATABASE = 'database'
}

export interface PermissionError {
    error: ErrorItem[];
    type: string;
}

interface ErrorItem {
    cause: string;
    value?: string;
    field?: string;
}

export interface GenericError {
    error: string;
    type: string;
}